import { enumToSuggestions } from '@shared/helpers/common.helper';
import { SelectItemModel } from '@shared/models/ComponentsModels/SelectItemModel';
import { EnumItemModel } from './ItemModels';

export enum EOrganizationType {
  Other = 0,
  Library = 1,
  K12Education = 2,
  AfterSchoolOrChildCare = 3,
}

enum EOrganizationTypeLabels {
  'Other',
  'Library',
  'K-12 Education',
  'Afterschool or Child Care',
}

export const OrganizationTypeEnumItems:
  ReadonlyArray<EnumItemModel<EOrganizationType>> = [
    { text: 'Other', value: EOrganizationType.Other },
    { text: 'Library', value: EOrganizationType.Library },
    { text: 'K-12 Education', value: EOrganizationType.K12Education },
    { text: 'Afterschool or Child Care', value: EOrganizationType.AfterSchoolOrChildCare },
  ];

export const OrganizationTypeSuggestions = enumToSuggestions(EOrganizationType)
  .map(({ value }: SelectItemModel) => ({
    value,
    text: EOrganizationTypeLabels[+value],
  }));
